import { SearchableFieldId } from '~/redux/api/methods/alert';

import { getFilterSuggestions } from './suggestions/filterSuggestionsOrchestrator';
import { SuggestionsResponse } from './suggestions/mergeSuggestionSources';
import {
  getPilotDocumentGroupSuggestions,
  getPilotPresetOptions,
} from './suggestions/pilotSuggestionsSource';

export enum SearchableFields {
  DocumentGroup = 'document_group_id',
  Folder = 'folder_id',
}

export interface GetFieldValuesParam {
  fieldId: SearchableFieldId;
  /** Unified Fields UUID; Evisearch addresses UF filters by it rather than by the pk. */
  ufFieldId?: string | null;
  searchSuggestions?: boolean;
  substringQuery?: string;
  presetOptionsOnly?: boolean;
}

export const getFieldValues = ({
  fieldId,
  ufFieldId,
  substringQuery = '',
  presetOptionsOnly = false,
}: GetFieldValuesParam): Promise<SuggestionsResponse> => {
  if (fieldId === SearchableFields.DocumentGroup) {
    return getPilotDocumentGroupSuggestions(fieldId, substringQuery);
  }

  if (presetOptionsOnly) {
    return getPilotPresetOptions(fieldId, substringQuery);
  }
  return getFilterSuggestions({
    filterId: String(ufFieldId ?? fieldId),
    pilotFieldId: String(fieldId),
    type: 'document',
    query: substringQuery,
  });
};
